module.exports = __webpack_public_path__ + "img/techcrunch.7be0a2d6.svg";